// The touch ledger's URL search, shared by the entry file (routes.tsx, validateSearch) and the screen. It lives in a
// module of its own so the screen never imports routes.tsx as a value: a route chunk that statically imports the module
// that lazy-loads it splits the shell into many small chunks (CONTRACTS 23.6, FX-F1-MEASURE-RED). The search holds ids
// and codes, never text: `?orgnr=<orgnr>` opens the log sheet with that organisation filled in (the router hands it back
// as a string or, written bare, a number), `&role=<RoleCode>` with it names the seat, `?contact=<ContactId>` one of the
// caller's contacts, and `?log=1` opens the sheet empty (the shell's l).

export interface TouchesSearch {
  orgnr?: string
  role?: string
  contact?: string
  log?: 1
}

const bare = (v: unknown) => String(v).replace(/^"(.*)"$/, '$1')
// the RoleCode and ContactId patterns of packages/shared/src/ids.ts, kept here so the entry file does not pull zod in
const ROLE = /^[A-Z]{4}$/
const CONTACT = /^ct_[0-9a-hjkmnp-tv-z]{26}$/

/** Router validateSearch, and the screen's own read: useSearch({ strict: false }) also hands back the raw search. */
export const parseSearch = (search: Record<string, unknown>): TouchesSearch => {
  const out: TouchesSearch = {}
  const orgnr = bare(search.orgnr)
  if (/^\d{9}$/.test(orgnr)) {
    out.orgnr = orgnr
    if (ROLE.test(bare(search.role))) out.role = bare(search.role)
  }
  if (CONTACT.test(bare(search.contact))) out.contact = bare(search.contact)
  if (bare(search.log) === '1') out.log = 1
  return out
}
